window.Branch = window.Branch || {};
window.Branch.productGallery = window.Branch.productGallery || {};

var galleryWindowWidth = window.innerWidth;

window.Branch.productGallery.initGallery = function(
  type, 
  item, 
  filterImages, 
  getCurrentVariant,  
  initSwiper, 
  initZoomSwiper, 
  product
){
  var productGallerySwiper;
  let mainProductGalleryOuterContainer= document.querySelector('.main-product-gallery__outer-container');
  let mainProductGalleryParent = mainProductGalleryOuterContainer.closest('.main-product-gallery');
  let mainProductGallerySwiperWrapper = mainProductGalleryOuterContainer.querySelector('.swiper-wrapper');
  let transition_time = 250;

/* Replace desktop gallery items with stand-ins while zoom gallery is open */

  const standInWhileZoomed = function(type){
    let standInOuterContainer = document.querySelector('.main-product__item[data-quick-view="false"] .main-product-gallery__zoom-stand-in');

    if(type == 'init'){
      let standInContainer = document.createElement("div");

      standInContainer.classList.add('main-product-gallery__zoom-stand-in-inner-container')
      
      let visibleSlides = document.querySelectorAll('.main-product__item[data-quick-view="false"] .main-product-gallery .main-product-gallery__item.slideVisible');
      
      if(visibleSlides.length > 0){
        visibleSlides.forEach((visibleSlide) => {
          let visibleSlideElement = visibleSlide.cloneNode(true);
          standInContainer.appendChild(visibleSlideElement)
        })
      }
      standInOuterContainer.appendChild(standInContainer);
    } else {
      standInOuterContainer.innerHTML = '';
    }
  }

  const refreshSwiper = function(zoomGallery, slideIndex, resize){
    let swiperDestroyedOrUnInit = productGallerySwiper ? false : true;
    let selector = `#main-product-item-${product.id} .main-product-gallery__outer-container`;
  
    if(productGallerySwiper && productGallerySwiper.destroyed == true){
      swiperDestroyedOrUnInit = true;
    }

    /* Params for mobile/quick-view swiper */

    let params =  {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + "</span>";
        },
      },
      on: {
        slideChange: function() {
          if (typeof window.galleryVideoPause === 'function') {
            window.galleryVideoPause();
          }
        }
      }
    }

    /* Params for desktop zoom-gallery swiper */

    let zoomParams = {
      loop: true,
      threshold: 5,
      initialSlide: slideIndex,
      toggle: false,
      allowTouchMove: true,
      navigation: {
        nextEl: ".main-product-gallery__nav-right.swiper-button-next",
        prevEl: ".main-product-gallery__nav-left.swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction"
      },
      on: {
        slideChange: function() {
          if (typeof window.galleryVideoPause === 'function') {
            window.galleryVideoPause();
          }
        }
      }
    }

    /* Various action to open desktop zoom swiper */

    const buildZoomSwiper = function(mainProductGalleryParent){
      mainProductGalleryParent.setAttribute('data-zoom', true);
      initZoomSwiper = true;
      standInWhileZoomed('init')
      window.Branch.functions.fixBody('fix');
      productGallerySwiper = new Swiper(selector, zoomParams);   
    }

    /* Various action to close desktop zoom swiper */
  
    const destroyZoomSwiper = function(mainProductGalleryParent){
      productGallerySwiper.destroy();
      standInWhileZoomed('destroy');
      document.querySelector(`#main-product-item-${product.id} .main-product-gallery__outer-container .swiper-wrapper`).removeAttribute('style');
      initSwiper = false;
      initZoomSwiper = false;
      mainProductGalleryParent.setAttribute('data-zoom', false);
      window.Branch.functions.fixBody('unfix');
      if(window.innerWidth < 900){
        productGallerySwiper = new Swiper(selector, params);   
        initSwiper = true;
      }
    }

    if(type == "quickView") {
      if(initSwiper == false){
          initSwiper = true;
          mainProductGalleryParent.setAttribute('data-zoom', false)
          quickViewSwiper = new Swiper(selector, params);   
      }
    }
     else if(window.innerWidth < 900) {
        if(initSwiper == false){
          if(initZoomSwiper == true){
            destroyZoomSwiper(mainProductGalleryParent)
          }
          initSwiper = true;
          mainProductGalleryParent.setAttribute('data-zoom', false)
          productGallerySwiper = new Swiper(selector, params);     
        } else if(resize != true) {
          productGallerySwiper.destroy();
          initSwiper = false
          buildZoomSwiper(mainProductGalleryParent)
        }
      }
       else {
        if(productGallerySwiper && initSwiper && type == 'main' && !zoomGallery){
            destroyZoomSwiper(mainProductGalleryParent)
        } else if(swiperDestroyedOrUnInit == true && zoomGallery == true && initSwiper == false && type == 'main' && initZoomSwiper == false && resize != true){
            buildZoomSwiper(mainProductGalleryParent)
        } else if (productGallerySwiper && zoomGallery == true && initSwiper == false && type == 'main' && initZoomSwiper == true){
            destroyZoomSwiper(mainProductGalleryParent)
        }
      };
      if(type != "quickView"){
        let displayMobileThumbnailGallery = document.querySelector('#mobile-pdp-gallery-test') && document.querySelector('#mobile-pdp-gallery-test').getAttribute('data-test-active') == 'true';
        if(displayMobileThumbnailGallery){
          window.Branch.productGallery.mobileThumbnailGallery(product.id);
        } else {
          window.Branch.productGallery.destroyExistingMobileThumbnailGallery(product.id)
        }
      }
      
  };

  const galleryHandleRefresh = function(){
    refreshSwiper(null, null, true);
  }

  const onGalleryResize = function() {
    if (window.innerWidth !== galleryWindowWidth) {
      galleryWindowWidth = window.innerWidth;
      galleryHandleRefresh();
    }
  }

  window.addEventListener('resize', window.Branch.functions.debounce(onGalleryResize, 150));
  
  refreshSwiper();

  window.Branch.functions.onImagesLoaded(item.find('.main-product-gallery__inner-container img'), function(){
    filterImages(getCurrentVariant(), true);
  });

  /* Background position adjust function */

  const AttachDragTo = (function() {
    let _AttachDragTo = function(el, imageContainerHeight, imageWidth) {
      this.el = el;
      this.imageContainerHeight = imageContainerHeight
      this.imageWidth = imageWidth;
      this.mouse_is_down = false;
  
      this.init();
    };
  
    _AttachDragTo.prototype = {
      onMousemove: function(e) {
        if (!this.mouse_is_down) return;
        let tg = e.target;
        if(tg.nodeName.toLowerCase() === "img"){
          tg = tg.parentElement;
        }
        let x = e.clientX,
          y = e.clientY,
          target_width = tg.clientWidth,
          target_height = tg.clientHeight,
          image_proportion,
          target_proportion,
          image_height = 1800, //Change this variable when changing the image.
          image_width = 1800, //Change this variable when changing the image.
          max_pos_x = 0,
          max_pos_y = 0;
          min_pos_x = 0,
          min_pos_y = 0;
          fifty_percent_container_height = this.imageContainerHeight / 2;
          fifty_percent_container_width = 500;
          

        image_proportion = target_height / image_height;
        target_proportion = target_width / target_height;

          max_pos_y = 1800 - target_height;
          max_pos_x = 800;

          min_pos_y = 0 - ((1800 - target_height) / 2);
          min_pos_x = -400;
  
          let image_bg_pos_x = x - this.origin_x + this.origin_bg_pos_x;
          let image_bg_pos_y = y - this.origin_y + this.origin_bg_pos_y;
  
          if (image_bg_pos_x < 0 && image_bg_pos_x > -max_pos_x) {
            tg.style.backgroundPositionX = `${image_bg_pos_x}px`;
          }
  
          if (image_bg_pos_y < 0 && image_bg_pos_y > -max_pos_y) {
            tg.style.backgroundPositionY = `${image_bg_pos_y}px`
          }
      },
  
      onMouseleave: function(e) {
        this.mouse_is_down = false;
        
        let tg = e.target,
          styles = getComputedStyle(tg);
  
        this.origin_bg_pos_x = parseInt(
          styles.getPropertyValue('background-position-x'),
          10
        );
        this.origin_bg_pos_y = parseInt(
          styles.getPropertyValue('background-position-y'),
          10
        );
        
        tg.style.cursor = 'grab';
      },
  
      onMousedown: function(e) {
        e.target.style.cursor = 'grabbing';
        
        this.mouse_is_down = true;
        this.origin_x = e.clientX;
        this.origin_y = e.clientY;
      },
  
      onMouseup: function(e) {
        let tg = e.target,
          styles = getComputedStyle(tg);
  
        this.mouse_is_down = false;
        
        this.origin_bg_pos_x = parseInt(
          styles.getPropertyValue('background-position-x'),
          10
        );
        this.origin_bg_pos_y = parseInt(
          styles.getPropertyValue('background-position-y'),
          10
        );
        
        tg.style.cursor = 'grab';
      },
  
      init: function() {
        let styles = getComputedStyle(this.el);
        this.origin_bg_pos_x = parseInt(
          styles.getPropertyValue('background-position-x'),
          10
        );
        this.origin_bg_pos_y = parseInt(
          styles.getPropertyValue('background-position-y'),
          10
        );
        
        let imageUrl = this.el.style.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
        let image = new Image();
        image.src = imageUrl;
  
        image.onload = () => {
          this.image_width = image.width,
            this.image_height = image.height;
        }
  
  
        //attach events
        this.el.addEventListener('mousedown', this.onMousedown.bind(this), false);
        this.el.addEventListener('mouseup', this.onMouseup.bind(this), false);
        this.el.addEventListener('mousemove', this.onMousemove.bind(this), false);
        this.el.addEventListener(
          'mouseleave',
          this.onMouseleave.bind(this),
          false
        );
      }
    };
  
    return function(el, imageContainerHeight, imageWidth) {
      new _AttachDragTo(el, imageContainerHeight, imageWidth);
    };
  })();

/* Check is background image is loaded before hiding gallery images and showing background image */

  const checkBackgroundImageLoaded = function(element, callback, imageContainer, imageContainerInner) {
    const intervalId = setInterval(() => {

      const backgroundImage = getComputedStyle(element).backgroundImage;
      let bgurl = backgroundImage.replace('url("', '').replace('")', '');
      let preloaderImg = document.createElement("img");
      preloaderImg.src = bgurl;
      if (backgroundImage && backgroundImage !== 'none') {
        preloaderImg.addEventListener('load', (event) => {
          clearInterval(intervalId);
          callback(imageContainer, imageContainerInner);
          preloaderImg = null;
      });
      }
    }, 100);
  }

  /* Adjust styling, attributes on background image load */

   const onBackgroundImageLoaded = function(imageContainer, imageContainerInner) {
    imageContainer.setAttribute('data-hide-image', true);

    let imageContainerHeight = imageContainerInner.offsetHeight;

    imageContainerInner.style.backgroundPositionX = '-400px'
    imageContainerInner.style.backgroundPositionY = `-${(1800 - imageContainerHeight) / 2}px`

    setTimeout(function(){
      let imageWidth = imageContainer.querySelector('img').naturalWidth;
      
      imageContainer.querySelector('img').style.display = 'none'

      AttachDragTo(imageContainerInner, imageContainerHeight, imageWidth);
    }, 10)
  }

  /* Begin zoom in by setting attributes, setting background load function in action */

  const zoomIn = function(imageContainer, imageContainerInner){
    imageContainer.setAttribute('data-zoom-activated', true);
    imageContainer.setAttribute('data-transitioning', 'in');
    setTimeout(() => {
      checkBackgroundImageLoaded(imageContainer.querySelector('.main-product-gallery__image-inner-container'), onBackgroundImageLoaded, imageContainer, imageContainerInner);
      imageContainer.setAttribute('data-transitioning', false);
    }, transition_time)
  }

  /* Begin zoom out by adjusting stylings, setting attributes */

  const zoomOut = function(imageContainer, imageContainerInner){
    imageContainer.querySelector('img').style.display = 'block';
    setTimeout(() => {
      imageContainer.setAttribute('data-zoom-activated', false);
      imageContainer.setAttribute('data-hide-image', false);
      imageContainer.setAttribute('data-transitioning', 'out');

      setTimeout(() => {
        imageContainerInner.style.backgroundPosition = "50% 50%";
        imageContainerInner.style.removeProperty('cursor')

        setTimeout(() => {

          let newimageContainerInner = imageContainerInner.cloneNode(true);

          imageContainerInner.parentNode.replaceChild(newimageContainerInner,imageContainerInner);
          imageContainerInner = newimageContainerInner;

          setTimeout(() => {
            imageContainer.setAttribute('data-transitioning', false);
          }, 15)
        }, transition_time - 45)  
      }, 15)
    }, 15)
  }

  const galleryZoom = function(type, imageContainer){
    let imageContainerInner = imageContainer ? imageContainer.querySelector('.main-product-gallery__image-inner-container') : document.querySelector('.main-product-gallery__image-container[data-zoom-activated="true"]  .main-product-gallery__image-inner-container');
    if(!imageContainer){
      imageContainer = document.querySelector('.main-product-gallery__image-container[data-zoom-activated="true"]');
    }
    if(type == "in"){
      zoomIn(imageContainer, imageContainerInner);
    } else {
      zoomOut(imageContainer, imageContainerInner);
    }
  }

  const buildZoomSwiper = function(event, slideIndex){
    let clickedOnEpigraph = false;
    if(event.target.nodeName.toLowerCase() == 'epigraph-ar' || event.target.closest('epigraph-ar') != null){
      clickedOnEpigraph = true;
    }
    if(clickedOnEpigraph == false){
      refreshSwiper(true, slideIndex);
    }
  }  

  const enterExitZoomState = function(event, mainProductGalleryOuterContainer){
    let imageContainer = event.target.classList.contains('main-product-gallery__image-container') ? event.target : event.target.closest('.main-product-gallery__image-container');

    if(imageContainer){
      if(mainProductGalleryOuterContainer.getAttribute('data-zoom-swiper-disabled') == "false"){
        mainProductGalleryOuterContainer.setAttribute('data-zoom-swiper-disabled', true)
        productGallerySwiper.allowTouchMove = false;
        setTimeout(function(){
          galleryZoom("in", imageContainer)
        }, 10)
      } else {
        mainProductGalleryOuterContainer.setAttribute('data-zoom-swiper-disabled', false)
        productGallerySwiper.allowTouchMove =  true;
        setTimeout(function(){
        galleryZoom("out", imageContainer)
        }, 10)
      }
    } else {
      if(mainProductGalleryOuterContainer.getAttribute('data-zoom-swiper-disabled') == "true"){
        mainProductGalleryOuterContainer.setAttribute('data-zoom-swiper-disabled', false)
        productGallerySwiper.allowTouchMove =  true;
        setTimeout(function(){
          galleryZoom("out", null)
        }, 10)
      }
    }
  }

  /* Returns true if slide has not been clicked on */

  const slideNotClickedOn = function(event){
    let haveNotClickedOnSlide = false;
    if(
      event.target.classList.contains('main-product-gallery__image-container') == false 
      && event.target.closest('.main-product-gallery__image-container') == null
      && event.target.classList.contains('main-product-gallery__video-container') == false 
      && event.target.closest('.main-product-gallery__video-container') == null
    ){
      haveNotClickedOnSlide = true
    }
    return haveNotClickedOnSlide;
  }

  /* Determine whether element was click on, or click/dragged across */

  const isClickedOn = function(event, startX, startY, delta){
    const diffX = Math.abs(event.pageX - startX);
    const diffY = Math.abs(event.pageY - startY);
    return diffX < delta && diffY < delta
  }

/* Determine index of clicked-on slide */

  const getIndexWithinSiblings = function(element) {
    if (!element || !element.parentElement) return -1; // Return -1 if the element or its parent is null
    
    var selector = `.main-product-gallery[data-product-id="${product.id}"] .main-product-gallery__item`;
    var siblings = Array.from(element.parentElement.querySelectorAll(selector));
    return siblings.indexOf(element);
}

  /* Work out what to do when click or click/drag is released */

  const zoomGalleryHandlePointerUp = function(event, delta, startX, startY){
    let targetSlide = event.target.classList.contains('main-product-gallery__item') ? event.target : event.target.closest('.main-product-gallery__item');
    let clickedOn = isClickedOn(event, startX, startY, delta);    
    let slideIndex = targetSlide ? getIndexWithinSiblings(targetSlide) : 0;
    if(targetSlide &&  targetSlide.classList.contains('is-video') || targetSlide && targetSlide.classList.contains('is-external-video')){
      clickedOn = false;
    }

    if(clickedOn) {
        if(initZoomSwiper == false){
          buildZoomSwiper(event, slideIndex);
        } 
        else {
          let imageContainer = event.target.classList.contains('main-product-gallery__image-container') ? event.target : event.target.closest('.main-product-gallery__image-container');
          let transitioning = imageContainer && imageContainer.getAttribute('data-transitioning') == "in" || imageContainer && imageContainer.getAttribute('data-transitioning') == "out" ? true : false; 
          let disabledSwiper = document.querySelector(`.main-product-gallery[data-product-id="${product.id}"] .main-product-gallery__outer-container[data-zoom-swiper-disabled="true"]`)
          

          if(window.Branch.functions.isTouchDevice() == false && transitioning == false){
            enterExitZoomState(event, mainProductGalleryOuterContainer, imageContainer);
          }
          
          if(slideNotClickedOn(event) && transitioning == false){
            let doNottRefresh = disabledSwiper && !imageContainer ? true : false;
            if(doNottRefresh == false){
              refreshSwiper(true, slideIndex);
            }
          }
        }
      }
  }

  const initCloseButton = function(){
    let closeButton = document.querySelector('.main-product-gallery .main-product-gallery__close-button');
    closeButton.addEventListener('click', function(){
      refreshSwiper(true, 0);
      let zoomedImageContainers = document.querySelectorAll('.main-product-gallery__image-container[data-zoom-activated="true"]');

      if(zoomedImageContainers.length > 0){
        document.querySelector(`.main-product-gallery[data-product-id="${product.id}"] .main-product-gallery__outer-container`).setAttribute('data-zoom-swiper-disabled', false)

        zoomedImageContainers.forEach((zoomedImageContainer) => {
          zoomOut(zoomedImageContainer, zoomedImageContainer.querySelector('.main-product-gallery__image-inner-container'))
        })
      }
    })
  }

  const initZoomGallery = function(){
    galleryWindowWidth = window.innerWidth;
    const delta = 6;
    let startX;
    let startY;

    if(type !== "quickView"){
      initCloseButton();
    }

    ['pointerdown'].forEach( function(evt) {
      mainProductGallerySwiperWrapper.addEventListener(evt, function(event){
        startX = event.pageX;
        startY = event.pageY;
      }, true); 
    });

    ['pointerup'].forEach( function(evt) {
      mainProductGallerySwiperWrapper.addEventListener(evt, function(event){
        zoomGalleryHandlePointerUp(event, delta, startX, startY);
      }, true); 
    });
  }


  initZoomGallery()

  initVideos('.main-product-gallery');

  if(document.body.classList.contains('templateProduct')) {
    const handleVideoVisibility = function() {
      const videoContainer = document.querySelector('.main-product-gallery__video-container');
      if(videoContainer) {
        const video = videoContainer.querySelector('video');
        const customPlayButton = videoContainer.querySelector('.custom-video-play');

        if(video && !video.paused) {
          const rect = videoContainer.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight && rect.bottom > 0;

          if(!isInView) {
            video.pause();
            video.removeAttribute('controls');
            if(customPlayButton) {
              customPlayButton.style.display = 'block';
            }
          }
        }
      }
    };

    window.addEventListener('scroll', handleVideoVisibility);
  }

  if(type == "quickView") {
    return quickViewSwiper;
  } else {
    return productGallerySwiper;
  }
}

var mobileThumbnailSwiper;
var mobileImageSwiper;

const initVideos = function(selector){
    const pauseAllPlayingVideos = function() {
      console.log('Pausing all playing videos');
        $(`${selector} video`).each(function() {
            if (!this.paused) {
                this.pause();
            }
        });
    };

    const loadAndPlayVideo = function(videoContainer, deferredMedia, videoType) {
        const template = deferredMedia.find('template')[0];
        if (template) {
            const content = template.content.cloneNode(true);

            deferredMedia.find('.deferred-media__poster').hide();
            deferredMedia.append(content);

            if (videoType === 'video') {
                const video = deferredMedia.find('video')[0];
                if (video) {
                    video.play();

                    $(video).on('pause', function() {
                        const currentTime = this.currentTime;
                        videoContainer.data('video-time', currentTime);

                        $(this).remove();
                        deferredMedia.find('.deferred-media__poster').show();

                        const playButton = videoContainer.find('.custom-video-play');
                        if (playButton.length) {
                            playButton.stop(true, false).fadeIn();
                        }
                    });

                    $(video).on('play', function() {
                        const playButton = videoContainer.find('.custom-video-play');
                        if (playButton.length) {
                            playButton.stop(true, false).fadeOut();
                        }
                    });

                    const storedTime = videoContainer.data('video-time');
                    if (storedTime && storedTime > 0) {
                        video.currentTime = storedTime;
                    }

                    $(video).on('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();

                        if (this.paused) {
                            this.play();
                        } else {
                            this.pause();
                        }
                    });
                }
            } else if (videoType === 'external_video') {
                const iframe = deferredMedia.find('iframe')[0];
                if (iframe) {
                    let src = iframe.src;
                    if (src.includes('youtube.com') || src.includes('youtu.be')) {
                        src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
                    } else if (src.includes('vimeo.com')) {
                        src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
                    }
                    iframe.src = src;

                    const playButton = videoContainer.find('.custom-video-play');
                    if (playButton.length) {
                        playButton.fadeOut();
                    }
                }
            }
        }
    };

    $(document).on('click', `${selector} .deferred-media__poster`, function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const deferredMedia = $(this).closest('.deferred-media');
        const videoContainer = $(this).closest('.main-product-gallery__video-container');
        const videoType = videoContainer.attr('data-video-type');

        if ($(this).is(':visible')) {
            loadAndPlayVideo(videoContainer, deferredMedia, videoType);
        }
    });

    $(document).on('click', `${selector} .custom-video-play`, function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const videoContainer = $(this).closest('.main-product-gallery__video-container');
        const videoType = videoContainer.attr('data-video-type');
        const deferredMedia = videoContainer.find('.deferred-media');
        const video = videoContainer.find('video')[0];

        if (video && !video.paused) {
            video.pause();
        } else {
            loadAndPlayVideo(videoContainer, deferredMedia, videoType);
        }
    });

    let scrollTimeout;
    $(window).on('scroll.videoControls', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
            $(`${selector} video`).each(function() {
                if (!this.paused) {
                    const videoContainer = $(this).closest('.main-product-gallery__video-container')[0];
                    if (videoContainer) {
                        const rect = videoContainer.getBoundingClientRect();
                        const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

                        if (!isInViewport) {
                            this.pause();
                        }
                    }
                }
            });
        }, 100); 
    });

    $(document).on('click.videoControls', `${selector} .swiper-button-next, ${selector} .swiper-button-prev, ${selector} .main-product-gallery__thumbnail`, function() {
        setTimeout(pauseAllPlayingVideos, 50);
    });

    if (!window.galleryVideoPause) {
        window.galleryVideoPause = pauseAllPlayingVideos;
    }
}

const updateMobileGalleryPaginationPosition = function(index, productId){
  let container = document.querySelector(`#main-product-item-${productId} .swiper-pagination`)
  let containersWidth = container.offsetWidth;
  let bullets = container.querySelectorAll('.swiper-pagination-bullet');
  let itemsCount = bullets.length;
  let tilesWidth = window.innerWidth >= 600 ? (itemsCount * 150) + ((itemsCount - 1) * 4) : (itemsCount * 110) + ((itemsCount - 1) * 4);

  if(window.innerWidth < 900 && container.closest('.main-product__item').getAttribute('data-quick-view') == 'false'){
    if(containersWidth < tilesWidth){
      let difference = tilesWidth - containersWidth;
      let percentageAcross = index == 0 ? 0 : index / (itemsCount - 1);
      if(bullets.length > 0){
        bullets.forEach((bullet) => {
          bullet.style.transform = `translateX(-${difference * percentageAcross}px)`
        })
      }
    } 
  }
}

window.Branch.productGallery.destroyExistingMobileThumbnailGallery = function(productId){
  if(mobileThumbnailSwiper){
    mobileThumbnailSwiper.destroy();
    mobileThumbnailSwiper = undefined;
  }

  if(mobileImageSwiper){
    mobileImageSwiper.destroy();
    mobileImageSwiper = undefined;
  }

  let mobileThumbnailSwiperElementInner = document.querySelector(`#main-product-item-${productId} .main-product-gallery__mobile-thumbnail-carousel .main-product-gallery__mobile-thumbnail-carousel-inner-container`);
  
  if(mobileThumbnailSwiperElementInner && mobileThumbnailSwiperElementInner.innerHTML){
    mobileThumbnailSwiperElementInner.innerHTML = '';
    mobileThumbnailSwiperElementInner.removeAttribute('id');
  }

  let mobileSwiperElementInner = document.querySelector(`#main-product-item-${productId} .main-product-gallery__mobile-carousel .main-product-gallery__mobile-carousel-inner-container`);
  
  if(mobileSwiperElementInner && mobileSwiperElementInner.innerHTML){
    mobileSwiperElementInner.innerHTML = '';
    mobileSwiperElementInner.removeAttribute('id');
  }

}

window.Branch.productGallery.mobileThumbnailGallery = function(productId, type){
  console.log('mobileThumbnailGallery', productId, type)
  let thumbnailImages = [];
  let startIndex = mobileImageSwiper && mobileImageSwiper.destroyed != true && mobileImageSwiper.activeIndex > 0 ? mobileImageSwiper.activeIndex : 0;
  // console.log('startIndex', startIndex)
  window.Branch.productGallery.destroyExistingMobileThumbnailGallery(productId)

  let standIn = document.querySelector(`#main-product-item-${productId} .main-product-gallery__mobile-image-carousel-stand-in`);

  let mobileThumbnailSwiperElement = document.querySelector(`#main-product-item-${productId} .main-product-gallery__mobile-thumbnail-carousel`);
  let mobileThumbnailSwiperElementInner = mobileThumbnailSwiperElement.querySelector('.main-product-gallery__mobile-thumbnail-carousel-inner-container');
  
  let mobileSwiperElement = document.querySelector(`#main-product-item-${productId} .main-product-gallery__mobile-carousel`);
  let mobileSwiperElementInner = mobileSwiperElement.querySelector('.main-product-gallery__mobile-carousel-inner-container');

  if(galleryWindowWidth < 900){
    let images = document.querySelectorAll(`#main-product-item-${productId} .main-product-gallery .main-product-gallery__item.slideVisible`);
    
    for (let i = 0; i < 3; i++) {
      images.forEach((image, index) => {
        let thumbnail;

        if(image.classList.contains('is-video')){
          thumbnail = `${window.Branch.functions.returnSingleSrc('src', image.querySelector('img').getAttribute('src'), 180)}#####video`;
        } else {
          thumbnail = window.Branch.functions.returnSingleSrc('srcset', image.querySelector('img.main-product__main-product-image').getAttribute('srcset'), 180);
        }
        thumbnailImages.push(thumbnail);

        let copyOfImage = image.cloneNode(true);

        copyOfImage.setAttribute('data-index', index);
        mobileSwiperElementInner.appendChild(copyOfImage);
      });
    }
    
    let swiperElementInnerHTML = ``;

      thumbnailImages.forEach((thumbnailImage) => {
        let playButton = '';
        
        if(thumbnailImage.includes('#####video')){
          thumbnailImage = thumbnailImage.split('#####video')[0];
          playButton = '<div class="pagination-play-button" role="button" aria-label="Play"><svg aria-hidden="true" role="presentation" class=" icon icon-play" viewBox="0 0 32 32"><path fill="#314438" d="M6.752,0.055l21.904,15.944L6.754,31.945"></path></svg></div>'
        }
        let newHTML = `<div class="main-product-gallery__mobile-thumbnail-carousel-item swiper-slide">${playButton}<img src="${thumbnailImage}"/></div>`;
        swiperElementInnerHTML = `${swiperElementInnerHTML}${newHTML}`
      })
    

      mobileThumbnailSwiperElementInner.innerHTML = swiperElementInnerHTML;

      mobileThumbnailSwiper = new Swiper(".main-product-gallery__mobile-thumbnail-carousel", {
        spaceBetween: 4,
        centeredSlides: false,
        slidesPerView: 'auto',
        initialSlide: startIndex,
        freeMode: true,
        slideToClickedSlide: true,
        // initialSlide: startIndex,
        watchSlidesProgress: true,
        // loopedSlides: 7,
        loop: true
      });

      const updateThumbnailPosition = function(startIndex){
        let elapsedTime = 0;
        const interval = 100; 
        const timeout = 10000; 

        const intervalId = setInterval(() => {
          elapsedTime += interval;

          const elements = document.querySelectorAll('.main-product-gallery__mobile-thumbnail-carousel-item.swiper-slide-thumb-active');
          if (elements.length > 0 || elapsedTime >= timeout) {
            // console.log('elements', elements.length, 'elapsedTime', elapsedTime)

            clearInterval(intervalId);
            let allItems = mobileThumbnailSwiperElementInner.querySelectorAll('.main-product-gallery__mobile-thumbnail-carousel-item');
            if(allItems.length > 0){
              allItems.forEach((item) => {
                // item.classList.remove('swiper-slide-thumb-active');
              })
            }
      
            let allActiveItems = mobileThumbnailSwiperElementInner.querySelectorAll(`.main-product-gallery__mobile-thumbnail-carousel-item[data-swiper-slide-index="${startIndex}"]`);
  
            if(allActiveItems.length > 0){
              allActiveItems.forEach((activeItem) => {
                // activeItem.classList.add('swiper-slide-thumb-active');
              })
            }
            
            document.querySelector('.main-product-gallery__mobile-thumbnail-carousel').setAttribute('data-thumbnail-position-updated', true);
            // mobileSwiperElement.realIndex = 0;
          }
        }, interval);
      }

      mobileImageSwiper = new Swiper(".main-product-gallery__mobile-carousel", {
          spaceBetween: 0,
          loop: false,
          initialSlide: startIndex,
          loopedSlides: 7,
          thumbs: {
            swiper: mobileThumbnailSwiper,
            multipleActiveThumbs: true
          },
          on: {
            init: function () {


              if(mobileSwiperElement.getAttribute('data-initialized') != 'true'){
                mobileSwiperElement.setAttribute('data-initialized', true);
              }
              setTimeout(() => {
              
                if(standIn.getAttribute('data-initialized') != 'true'){
                  standIn.setAttribute('data-initialized', true);
                }

                if(mobileThumbnailSwiperElement.getAttribute('data-thumbnail-position-updated') != "true"){
                  updateThumbnailPosition(startIndex);
                }
              }, 500);
            }
          }
      });

      

    

      // mobileThumbnailSwiper.controller.control = mobileImageSwiper;
      // mobileImageSwiper.controller.control = mobileThumbnailSwiper;

      // console.log('right at the end', mobileImageSwiper.activeIndex, 'startIndex', startIndex)

      initVideos('.main-product-gallery__mobile-carousel');
    }
}
